<template>
  <div class="basicPortContent">
    <!--路由分隔-->
    <Breadcrumb :matched="matched" />
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基础船舶" name="basicShip">
        <basicShip v-if="basicShip" />
      </el-tab-pane>
      <el-tab-pane label="基础船舶(可修改)" name="modifiableBasicShip">
        <modifiable-vessel v-if="modifiableBasicShip" />
      </el-tab-pane>
      <el-tab-pane label="船期船舶" name="dataShip">
        <dataShip v-if="dataShip" />
      </el-tab-pane>
      <el-tab-pane label="跟踪船舶" name="trackShip">
        <trackShip v-if="trackShip" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import basicShip from './basicShip.vue'
import dataShip from './dataShip.vue'
import trackShip from './trackShip.vue'
import ModifiableVessel from './ModifiableVessel.vue'
export default {
  components: {
    Breadcrumb,
    basicShip,
    dataShip,
    trackShip,
    ModifiableVessel,
  },
  data() {
    return {
      matched: '',
      activeName: 'basicShip',
      basicShip: true,
      dataShip: false,
      trackShip: false,
      modifiableBasicShip: false,
    }
  },
  mounted() {
    this.matched = this.$route.matched
  },
  destroyed() {
    this.$bus.off('clickMenu')
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == '基础船舶') {
        this.basicShip = true
        this.dataShip = false
        this.trackShip = false
        this.modifiableBasicShip = false
      } else if (tab.label == '船期船舶') {
        this.basicShip = false
        this.dataShip = true
        this.trackShip = false
        this.modifiableBasicShip = false
      } else if (tab.label == '跟踪船舶') {
        this.basicShip = false
        this.dataShip = false
        this.trackShip = true
        this.modifiableBasicShip = false
      } else if (tab.label == '基础船舶(可修改)') {
        this.basicShip = false
        this.dataShip = false
        this.trackShip = false
        this.modifiableBasicShip = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.basicPortContent {
  padding: 20px 20px 0px 20px;

  .el-tabs {
    background-color: #fff;
    padding: 10px 0px 20px 0px;
  }

  ::v-deep.el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }

  ::v-deep.el-tabs__item:hover {
    color: #333;
  }

  ::v-deep.el-tabs__item {
    font-size: 13px;
  }

  ::v-deep.el-tabs__nav-scroll {
    padding-left: 20px;
  }
}
</style>
